import { render } from "./RecantsPage.vue?vue&type=template&id=b696f6b0&ts=true"
import script from "./RecantsPage.vue?vue&type=script&lang=ts"
export * from "./RecantsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__